export function buildClinicalItems({ notes = [], assessments = [], revisions = [], templates = [], versions = [], users = [] }) {
  const templatesById = new Map(templates.map(item => [item.id, item]));
  const versionsById = new Map(versions.map(item => [item.id, item]));
  const usersById = new Map(users.map(item => [item.id, item]));
  const revisionsByAssessment = new Map();
  revisions.forEach(revision => {
    const existing = revisionsByAssessment.get(revision.assessment_id) || [];
    existing.push({
      ...revision,
      authorName: usersById.get(revision.submitted_by)?.name || 'Unknown Clinician',
    });
    revisionsByAssessment.set(revision.assessment_id, existing);
  });
  const noteItems = notes.map(note => ({
    kind: 'note', ...note, doctorName: usersById.get(note.doctor_id)?.name || 'Unknown Doctor',
  }));
  const assessmentItems = assessments.map(assessment => {
    const revisionHistory = [...(revisionsByAssessment.get(assessment.id) || [])]
      .sort((left, right) => left.revision_number - right.revision_number);
    return {
      kind: 'assessment', ...assessment,
      template: templatesById.get(assessment.template_id) || null,
      version: versionsById.get(assessment.template_version_id) || null,
      latestRevision: revisionHistory.at(-1) || null,
      revisionHistory,
      doctorName: usersById.get(assessment.author_id)?.name || 'Unknown Doctor',
      entered_in_error_actor_name: usersById.get(assessment.entered_in_error_by)?.name || (assessment.entered_in_error_by ? 'Unknown Clinician' : ''),
    };
  });
  return [...noteItems, ...assessmentItems].sort((left, right) => new Date(left.created_at) - new Date(right.created_at));
}

export function splitClinicalItems(items = []) {
  const defaultItems = [];
  const enteredInErrorItems = [];
  items.forEach(item => {
    if (item.kind === 'assessment' && item.status === 'entered_in_error') {
      enteredInErrorItems.push(item);
    } else {
      defaultItems.push(item);
    }
  });
  return { defaultItems, enteredInErrorItems };
}
